import { Room } from '../../models/room';

export class SetRoom {
    public static readonly type = '[MessagingState] Set room';

    constructor(public room: Room) {}
}
